import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { createRef, PureComponent } from 'react';
import { inputStyles } from './styles';
import { PROPS_TO_FILTER } from './constants';
import { processDateChange } from './utils';
import { validateCardExpiry, validateCardIssueDate } from './validations';
import { FloatingLabelInput } from '../../FloatingLabelInput';
import { filterProps, isElementFocused, isNumber, safeNormalize } from '../../../../utils';
import { rtlNumberOnlyStyles } from '../../commonStyles';

class CardDate extends PureComponent {
  constructor(props) {
    super(props);

    _defineProperty(this, "changeHandler", (event, newValue, prevValue) => {
      var _event$persist;

      (_event$persist = event.persist) === null || _event$persist === void 0 ? void 0 : _event$persist.call(event);
      var {
        changeHandlerArgs,
        selectionRange
      } = processDateChange({
        event,
        newValue,
        prevValue,
        props: this.props,
        validationFn: this.validationFn
      });
      this.setState(() => ({
        selectionRange
      }));
      this.props.changeHandler(...changeHandlerArgs);
    });

    this.state = {
      selectionRange: {}
    };
    var isIssueDate = props.cardDateType === 'issue';
    this.validationFn = isIssueDate ? validateCardIssueDate : validateCardExpiry;
    this.cardDateRef = props.forwardedRef || createRef(this, 'cardDateRef');
  }

  componentDidUpdate() {
    var {
      end,
      start
    } = this.state.selectionRange;

    if (!isNumber(start) || !isNumber(end)) {
      return;
    }

    var isFocused = isElementFocused(this.cardDateRef.current);

    if (isFocused) {
      var _this$cardDateRef$cur, _this$cardDateRef$cur2;

      (_this$cardDateRef$cur = this.cardDateRef.current) === null || _this$cardDateRef$cur === void 0 ? void 0 : (_this$cardDateRef$cur2 = _this$cardDateRef$cur.setSelectionRange) === null || _this$cardDateRef$cur2 === void 0 ? void 0 : _this$cardDateRef$cur2.call(_this$cardDateRef$cur, start, end);
    }
  }

  render() {
    var filteredProps = filterProps(this.props, PROPS_TO_FILTER);
    var {
      inputStyleOverrides
    } = this.props;
    return React.createElement(FloatingLabelInput, _extends({}, filteredProps, {
      changeHandler: this.changeHandler,
      forwardedRef: this.cardDateRef,
      inputStyleOverrides: [inputStyles, rtlNumberOnlyStyles, inputStyleOverrides],
      pattern: "\\\\d{2}\\\\s\\\\/\\\\s\\\\d{2}",
      preprocessFn: safeNormalize,
      type: "tel",
      validationFn: this.validationFn
    }));
  }

}

export { CardDate };